import { Injectable } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { HttpClientService } from "./http-client.service";
import {
  LeadRecoveryDashboardParams,
  LeadRecoveryDashboardResponse,
  LeadRecoverySearchResponse,
} from "../interfaces/lead-recovery/lead-recovery.interface";

@Injectable({ providedIn: "root" })
export class LeadRecoveryService {
  private readonly BASE = "/api/lead_recoveries";

  constructor(private readonly http: HttpClientService) {}

  getDashboard(filters?: LeadRecoveryDashboardParams): Observable<LeadRecoveryDashboardResponse> {
    let params = new HttpParams();
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          params = params.set(key, String(value));
        }
      });
    }
    return this.http.get<LeadRecoveryDashboardResponse>(`${this.BASE}/dashboard`, { params });
  }

  searchByPerson(personId: number): Observable<LeadRecoverySearchResponse> {
    const params = new HttpParams().set("person_id", String(personId));
    return this.http.get<LeadRecoverySearchResponse>(`${this.BASE}/search`, { params });
  }
}
